import * as React from 'react';
import clsx from 'clsx';

interface Props {
  className?: string;
  children?: React.ReactNode;
  'data-testid'?: string;
  modifierClassName?: string;
  autoComplete?: string;
  method?: string;
  onSubmit?(event: React.FormEvent<HTMLFormElement>): void;
}

/**
 * @deprecated
 * Use Form from Formik
 */
export default class Form extends React.PureComponent<Props> {
  static defaultProps: Partial<Props> = {
    modifierClassName: 'Form--default',
    method: 'post',
  };

  handleProtectDefaultSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    if (this.props.onSubmit) {
      this.props.onSubmit(event);
    }
  };

  render() {
    const {
      children,
      className: classNameFromProps,

      method,
      autoComplete,
      modifierClassName,
    } = this.props;

    const className = clsx('Form', classNameFromProps, modifierClassName);

    return (
      <form
        className={className}
        data-testid={this.props['data-testid']}
        method={method}
        autoComplete={autoComplete}
        noValidate={true}
        onSubmit={this.handleProtectDefaultSubmit}
      >
        {children}
      </form>
    );
  }
}
